import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, postApi } from 'services/_api';
import { CHANNEL_DETRAN, PATH_CONTABILIZA } from 'services/_path';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types, EventoConfrontoSessaoRequest } from './types';

// ACTIONS
import {
	eventoConfrontoSessaoSuccess,
	eventoConfrontoSessaoFailure,
} from './actions';

function* eventoConfrontoSessao(request: ReducerAction) {
	const { payload }: { payload: EventoConfrontoSessaoRequest } = request;

	const response: ApiResponse = yield call(
		postApi,
		PATH_CONTABILIZA,
		`evento/${CHANNEL_DETRAN}/confronto`,
		payload,
		undefined,
		true,
	);

	if (response.status === 200) {
		yield put(eventoConfrontoSessaoSuccess(response));
	} else {
		yield put(eventoConfrontoSessaoFailure(response));
	}
}

export default all([
	takeLatest(Types.EVENTO_CONFRONTO_SESSAO_REQUEST, eventoConfrontoSessao),
]);
